import { collection, query, where, orderBy, limit, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";

export async function Ledger_accounts_balance(accountguid) {
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken || !guid || !select_company_uid) {
    return 0; // always return a number
  }
const servicetablename = "accountingfinancedb";
  try {
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_books"
    );

    const lastQuery = query(
      ledgerCollection,
      where("accountguid", "==", accountguid),
      orderBy("date_time", "desc"),
      limit(1)
    );

    const lastSnap = await getDocs(lastQuery);

    if (!lastSnap.empty) {
      return lastSnap.docs[0].data().balance || 0;
    }

    return 0;
  } catch (error) {
    return 0;
  }
}
